import {
  ORDER_CREATE_REQUEST,
  ORDER_CREATE_SUCCESS,
  ORDER_CREATE_FAIL,
  ORDER_DETAILS_REQUEST,
  ORDER_DETAILS_SUCCESS,
  ORDER_DETAILS_FAIL,
  ORDER_PAY_REQUEST,
  ORDER_PAY_SUCCESS,
  ORDER_PAY_FAIL,
  ORDER_PAY_RESET,
  ORDER_CREATE_INVOICE_PAY_XENDIT_REQUEST,
  ORDER_CREATE_INVOICE_PAY_XENDIT_SUCCESS,
  ORDER_CREATE_INVOICE_PAY_XENDIT_FAIL,
  ORDER_CREATE_INVOICE_PAY_XENDIT_RESET,
  ORDER_PAY_XENDIT_REQUEST,
  ORDER_PAY_XENDIT_SUCCESS,
  ORDER_PAY_XENDIT_FAIL,
  ORDER_PAY_XENDIT_RESET,
  ORDER_MY_LIST_REQUEST,
  ORDER_MY_LIST_SUCCESS,
  ORDER_MY_LIST_FAIL,
  ORDER_MY_LIST_RESET,
  ORDER_ALL_LIST_REQUEST,
  ORDER_ALL_LIST_SUCCESS,
  ORDER_ALL_LIST_FAIL,
  ORDER_DELIVER_REQUEST,
  ORDER_DELIVER_SUCCESS,
  ORDER_DELIVER_FAIL,
  ORDER_DELIVER_RESET,
  ORDER_ZEROPAY_REQUEST,
  ORDER_ZEROPAY_SUCCESS,
  ORDER_ZEROPAY_FAIL,
  ORDER_ZEROPAY_RESET,
  ORDER_FOR_ME_LIST_REQUEST,
  ORDER_FOR_ME_LIST_SUCCESS,
  ORDER_FOR_ME_LIST_FAIL,
  ORDER_FOR_ME_LIST_RESET,
} from '../constants/orderConstants';

export const orderCreateReducer = (state = {}, action) => {
  switch (action.type) {
    case ORDER_CREATE_REQUEST:
      return {
        loading: true,
      };
    case ORDER_CREATE_SUCCESS:
      return {
        loading: false,
        success: true,
        order: action.payload,
      };
    case ORDER_CREATE_FAIL:
      return {
        loading: false,
        success: false,
        order: action.payload,
      };
    default:
      return state;
  }
};

export const orderDetailsReducer = (
  state = {
    loading: true /*default to true*/,
    orderItems: [],
    shippingAddress: {},
  },
  action
) => {
  switch (action.type) {
    case ORDER_DETAILS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case ORDER_DETAILS_SUCCESS:
      return {
        loading: false,
        order: action.payload,
      };
    case ORDER_DETAILS_FAIL:
      return {
        loading: false,
        order: action.payload,
      };
    default:
      return state;
  }
};

export const orderPayReducer = (state = {}, action) => {
  switch (action.type) {
    case ORDER_PAY_REQUEST:
      return {
        loading: true,
      };
    case ORDER_PAY_SUCCESS:
      return {
        loading: false,
        success: true,
      };
    case ORDER_PAY_FAIL:
      return {
        loading: false,
        error: action.payload,
      };
    case ORDER_PAY_RESET:
      return {};
    default:
      return state;
  }
};

export const orderCreateInvoicePayXenditReducer = (state = {}, action) => {
  switch (action.type) {
    case ORDER_CREATE_INVOICE_PAY_XENDIT_REQUEST:
      return {
        loading: true,
      };
    case ORDER_CREATE_INVOICE_PAY_XENDIT_SUCCESS:
      return {
        loading: false,
        success: true,
        invoiceData: action.payload,
      };
    case ORDER_CREATE_INVOICE_PAY_XENDIT_FAIL:
      return {
        loading: false,
        success: false,
        error: action.payload,
      };
    case ORDER_CREATE_INVOICE_PAY_XENDIT_RESET:
      return {};
    default:
      return state;
  }
};

export const orderPayXenditReducer = (state = {}, action) => {
  switch (action.type) {
    case ORDER_PAY_XENDIT_REQUEST:
      return {
        loading: true,
      };
    case ORDER_PAY_XENDIT_SUCCESS:
      return {
        loading: false,
        // success: true,
        paymentData: action.payload,
      };
    case ORDER_PAY_XENDIT_FAIL:
      return {
        loading: false,
        success: false,
        error: action.payload,
      };
    case ORDER_PAY_XENDIT_RESET:
      return {};
    default:
      return state;
  }
};

export const orderDeliverReducer = (state = {}, action) => {
  switch (action.type) {
    case ORDER_DELIVER_REQUEST:
      return {
        loading: true,
      };
    case ORDER_DELIVER_SUCCESS:
      return {
        loading: false,
        success: true,
      };
    case ORDER_DELIVER_FAIL:
      return {
        loading: false,
        error: action.payload,
      };
    case ORDER_DELIVER_RESET:
      return {};
    default:
      return state;
  }
};

export const orderZeroPayReducer = (state = {}, action) => {
  switch (action.type) {
    case ORDER_ZEROPAY_REQUEST:
      return {
        loading: true,
      };
    case ORDER_ZEROPAY_SUCCESS:
      return {
        loading: false,
        success: true,
        orderZeroPayResult: action.payload,
      };
    case ORDER_ZEROPAY_FAIL:
      return {
        loading: false,
        error: action.payload,
      };
    case ORDER_ZEROPAY_RESET:
      return {};
    default:
      return state;
  }
};

export const ordersMyListReducer = (state = { orders: [] }, action) => {
  switch (action.type) {
    case ORDER_MY_LIST_REQUEST:
      return {
        loading: true,
      };
    case ORDER_MY_LIST_SUCCESS:
      return {
        loading: false,
        orders: action.payload,
      };
    case ORDER_MY_LIST_FAIL:
      return {
        loading: false,
        error: action.payload,
      };
    case ORDER_MY_LIST_RESET:
      return { orders: [] };
    default:
      return state;
  }
};

export const ordersForMeReducer = (state = { orders: [] }, action) => {
  switch (action.type) {
    case ORDER_FOR_ME_LIST_REQUEST:
      return {
        loading: true,
      };
    case ORDER_FOR_ME_LIST_SUCCESS:
      return {
        loading: false,
        orders: action.payload,
      };
    case ORDER_FOR_ME_LIST_FAIL:
      return {
        loading: false,
        error: action.payload,
      };
    case ORDER_FOR_ME_LIST_RESET:
      return { orders: [] };
    default:
      return state;
  }
};

export const ordersAllListReducer = (state = { orders: [] }, action) => {
  switch (action.type) {
    case ORDER_ALL_LIST_REQUEST:
      return {
        loading: true,
      };
    case ORDER_ALL_LIST_SUCCESS:
      return {
        loading: false,
        orders: action.payload,
      };
    case ORDER_ALL_LIST_FAIL:
      return {
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};
